import AccordionHeader from './AccordionHeader';

export default AccordionHeader;
